import React from 'react'

/**
 * Shared SVG gradient definitions for AI-related components
 */
export const AiGradients: React.FC = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }}>
    <defs>
      {/* Blue-green gradient for all AI sparkle icons */}
      <linearGradient id="sparkle-gradient-blue" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3098D1" />
        <stop offset="100%" stopColor="#14CC95" />
      </linearGradient>
    </defs>
  </svg>
)

export default AiGradients
